webpackJsonp([898851859872],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(121));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(140);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(60);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(149);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _promise = __webpack_require__(110);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderers = [];
	var recaptchaId = null;
	
	var ReCAPTCHA = function (_React$Component) {
	  (0, _inherits3.default)(ReCAPTCHA, _React$Component);
	
	  function ReCAPTCHA() {
	    (0, _classCallCheck3.default)(this, ReCAPTCHA);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleErrored = _this.handleErrored.bind(_this);
	    _this.injectScript = _this.injectScript.bind(_this);
	    _this.createRecaptcha = _this.createRecaptcha.bind(_this);
	    _this.destroyRecaptcha = _this.destroyRecaptcha.bind(_this);
	    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
	    return _this;
	  }
	
	  ReCAPTCHA.prototype.injectScript = function injectScript() {
	    window.GoogleRecaptchaLoaded = function () {
	      while (renderers.length) {
	        var renderer = renderers.pop();
	        renderer();
	      }
	    };
	
	    var script = document.createElement('script');
	    script.id = 'recaptcha';
	    script.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=GoogleRecaptchaLoaded&render=explicit';
	    script.type = 'text/javascript';
	    script.async = true;
	    script.defer = true;
	    script.onerror = function (error) {
	      throw error;
	    };
	    document.body.appendChild(script);
	    var $style = document.createElement('style');
	    if (!document.querySelector('style[id="grecaptcha-style"]')) {
	      $style.id = 'grecaptcha-style';
	      $style.innerHTML = '.grecaptcha-badge{visibility: hidden;}';
	      document.head.appendChild($style);
	    }
	  };
	
	  ReCAPTCHA.prototype.execute = function execute() {
	    if (window.grecaptcha && recaptchaId !== undefined) {
	      return window.grecaptcha.execute(recaptchaId);
	    } else {
	      this._executeRequested = true;
	    }
	  };
	
	  ReCAPTCHA.prototype.getRecaptchaToken = function getRecaptchaToken() {
	    var _this2 = this;
	
	    this.reset();
	    return new _promise2.default(function (resolve, reject) {
	      _this2.executionResolve = resolve;
	      _this2.executionReject = reject;
	      _this2.execute();
	    });
	  };
	
	  ReCAPTCHA.prototype.reset = function reset() {
	    if (window.grecaptcha && recaptchaId !== undefined) {
	      window.grecaptcha.reset(recaptchaId);
	    }
	  };
	
	  ReCAPTCHA.prototype.handleErrored = function handleErrored(error) {
	    if (this.props.onErrored) {
	      this.props.onErrored();
	    }
	    if (this.executionReject) {
	      if (error === undefined) error = 'Invalid request';
	      this.executionReject(error);
	      delete this.executionResolve;
	      delete this.executionReject;
	    }
	  };
	
	  ReCAPTCHA.prototype.handleChange = function handleChange(token) {
	    if (this.props.onChange) {
	      this.props.onChange(token);
	    }
	    if (this.executionResolve) {
	      this.executionResolve(token);
	      delete this.executionReject;
	      delete this.executionResolve;
	    }
	  };
	
	  ReCAPTCHA.prototype.createRecaptcha = function createRecaptcha() {
	    var _this3 = this;
	
	    var loaded = function loaded() {
	      if (_this3.captcha) {
	        var wrapper = document.createElement("div");
	        recaptchaId = window.grecaptcha.render(wrapper, {
	          sitekey: _this3.props.sitekey,
	          size: 'invisible',
	          badge: 'bottomleft',
	          callback: _this3.handleChange,
	          "expired-callback": _this3.handleChange(null),
	          "error-callback": _this3.handleErrored
	        });
	        _this3.captcha.appendChild(wrapper);
	      }
	    };
	
	    if (+("1")) {
	      if (window.grecaptcha && window.grecaptcha.render && recaptchaId === undefined) {
	        loaded();
	      } else {
	        renderers.push(loaded);
	        if (!document.querySelector('#recaptcha')) {
	          this.injectScript();
	        }
	      }
	    }
	
	    if (this._executeRequested && window.grecaptcha && recaptchaId !== undefined) {
	      this._executeRequested = false;
	      this.execute();
	    }
	  };
	
	  ReCAPTCHA.prototype.destroyRecaptcha = function destroyRecaptcha() {
	    if (this.captcha && window.grecaptcha) {
	      while (this.captcha.firstChild) {
	        this.captcha.removeChild(this.captcha.firstChild);
	      }
	      window.grecaptcha.reset(recaptchaId);
	      delete window['grecaptcha'];
	    }
	    var removeStyles = document.querySelector('style[id="grecaptcha-style"]');
	    if (removeStyles) document.head.removeChild(removeStyles);
	    var removeScripts = document.querySelector('script[id="recaptcha"]');
	    if (removeScripts) document.body.removeChild(removeScripts);
	  };
	
	  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
	    this.createRecaptcha();
	  };
	
	  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.createRecaptcha();
	  };
	
	  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.destroyRecaptcha();
	  };
	
	  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
	    this.captcha = elem;
	  };
	
	  ReCAPTCHA.prototype.render = function render() {
	    var _props = this.props,
	        sitekey = _props.sitekey,
	        onChange = _props.onChange,
	        theme = _props.theme,
	        type = _props.type,
	        tabindex = _props.tabindex,
	        onExpired = _props.onExpired,
	        onErrored = _props.onErrored,
	        size = _props.size,
	        stoken = _props.stoken,
	        badge = _props.badge,
	        hl = _props.hl,
	        isolated = _props.isolated,
	        childProps = (0, _objectWithoutProperties3.default)(_props, ['sitekey', 'onChange', 'theme', 'type', 'tabindex', 'onExpired', 'onErrored', 'size', 'stoken', 'badge', 'hl', 'isolated']);
	
	
	    return React.createElement(
	      'div',
	      { className: 'form-row-recaptcha' },
	      'This site is protected by reCAPTCHA and the Google ',
	      React.createElement(
	        'a',
	        { href: 'https://policies.google.com/privacy' },
	        'Privacy Policy'
	      ),
	      ' and ',
	      React.createElement(
	        'a',
	        { href: 'https://policies.google.com/terms' },
	        'Terms of Service'
	      ),
	      ' apply.',
	      React.createElement('div', (0, _extends3.default)({}, childProps, { ref: this.handleRecaptchaRef }))
	    );
	  };
	
	  return ReCAPTCHA;
	}(React.Component);
	
	exports.default = ReCAPTCHA;
	
	
	ReCAPTCHA.displayName = "ReCAPTCHA";
	module.exports = exports['default'];

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _regenerator = __webpack_require__(195);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(193);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouterDom = __webpack_require__(42);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	var _SingleInput = __webpack_require__(35);
	
	var _SingleInput2 = _interopRequireDefault(_SingleInput);
	
	var _ReCaptcha = __webpack_require__(109);
	
	var _ReCaptcha2 = _interopRequireDefault(_ReCaptcha);
	
	var _sha = __webpack_require__(122);
	
	var _sha2 = _interopRequireDefault(_sha);
	
	var _reactCookies = __webpack_require__(68);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _logo = __webpack_require__(432);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _logo_newYear = __webpack_require__(433);
	
	var _logo_newYear2 = _interopRequireDefault(_logo_newYear);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reCaptcha = void 0;
	
	var Login = function (_React$Component) {
	  (0, _inherits3.default)(Login, _React$Component);
	
	  function Login(props) {
	    (0, _classCallCheck3.default)(this, Login);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.onInputFocus = _this.onInputFocus.bind(_this);
	
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);
	    _this.handleFacebook = _this.handleFacebook.bind(_this);
	
	    _this.initFacebook = _this.initFacebook.bind(_this);
	    _this.statusFacebookCallback = _this.statusFacebookCallback.bind(_this);
	
	    _this.checkForm = _this.checkForm.bind(_this);
	    _this.postDataForm = _this.postDataForm.bind(_this);
	    _this.postFacebookDataForm = _this.postFacebookDataForm.bind(_this);
	    _this.state = {
	      statusPage: false,
	      redirectPage: false,
	      redirectPath: '',
	      email: '',
	      password: '',
	      type: 'login',
	      facebookAccessToken: '',
	      facebookSignedRequest: '',
	      facebookType: 'login',
	
	      loginError: '',
	      loginDisabled: false,
	      facebookDisabled: false
	    };
	    return _this;
	  }
	
	  Login.prototype.pageClick = function pageClick(e) {
	    document.getElementsByTagName('body')[0].className = '';
	  };
	
	  Login.prototype.onInputFocus = function onInputFocus(s) {
	    (0, _GlobalFunctions.addClass)(s.target.parentNode, "input--filled"), this.setState({ loginError: '' });
	  };
	
	  Login.prototype.onInputBlur = function onInputBlur(s) {
	    "" === s.target.value.trim() && (0, _GlobalFunctions.removeClass)(s.target.parentNode, "input--filled");
	  };
	
	  Login.prototype.handleEmailChange = function handleEmailChange(e) {
	    this.setState({ email: e.target.value });
	  };
	
	  Login.prototype.handlePasswordChange = function handlePasswordChange(e) {
	    this.setState({ password: e.target.value });
	  };
	
	  Login.prototype.postDataForm = function postDataForm(token) {
	    var self = this;
	    var username = this.state.email;
	    var _state = this.state,
	        password = _state.password,
	        type = _state.type;
	
	    var d = new Date();
	    var time_zone_offset = d.getTimezoneOffset();
	    var recaptchaToken = token ? "&recaptchaToken=" + token : '';
	
	    (0, _GlobalFunctions.getJSON)('POST', '/api/auth', 'username=' + username + '&password=' + (0, _sha2.default)(password) + '&time_zone_offset=' + time_zone_offset + '&type=' + type + recaptchaToken, function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
	        var dataArray, currentRecaptchaToken;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataArray = JSON.parse(data);
	
	                if (!(dataArray.type && dataArray.type !== type)) {
	                  _context.next = 13;
	                  break;
	                }
	
	                self.setState({ loginError: '<p class="info">' + dataArray.message + '</p>', type: dataArray.type });
	
	                if (!+("1")) {
	                  _context.next = 10;
	                  break;
	                }
	
	                _context.next = 6;
	                return reCaptcha.getRecaptchaToken();
	
	              case 6:
	                currentRecaptchaToken = _context.sent;
	
	                self.postDataForm(currentRecaptchaToken);
	                _context.next = 11;
	                break;
	
	              case 10:
	                self.postDataForm();
	
	              case 11:
	                _context.next = 22;
	                break;
	
	              case 13:
	                _context.t0 = type;
	                _context.next = _context.t0 === 'reactivate' ? 16 : _context.t0 === 'proceed' ? 18 : 21;
	                break;
	
	              case 16:
	                window.location.assign(("") + '/orders/available.html');
	                return _context.abrupt("break", 22);
	
	              case 18:
	                self.setState({ redirectPath: '/register_hash.html' });
	                self.setState({ redirectPage: true });
	                return _context.abrupt("break", 22);
	
	              case 21:
	                window.location.assign(dataArray.redirect ? dataArray.redirect : ("") + '/orders/available.html');
	
	              case 22:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }(), function (status) {
	      var statusArray = JSON.parse(status);
	
	      if (statusArray.fields && statusArray.fields !== 'undefined') {
	        var loginErrorFields = '';
	        if (statusArray.fields.length > 0) {
	          for (var i = 0; i < statusArray.fields.length; i++) {
	            loginErrorFields += '<p>' + statusArray.fields[i] + '</p>';
	          }
	        }
	        self.setState({ loginError: loginErrorFields });
	      } else if (statusArray.message && statusArray.message !== 'undefined') {
	        self.setState({ loginError: '<p>' + statusArray.message + '</p>' });
	      }
	      self.setState({ loginDisabled: false });
	    });
	  };
	
	  Login.prototype.checkForm = function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
	      var self, CookieDialog_agreed, recaptchaToken;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              e.preventDefault();
	
	              self = this, CookieDialog_agreed = _reactCookies2.default.load('CookieDialog_agreed');
	
	              if (CookieDialog_agreed) {
	                _context2.next = 6;
	                break;
	              }
	
	              this.setState({ loginError: '<p>Please accept cookie policy to proceed.</p>' });
	              _context2.next = 20;
	              break;
	
	            case 6:
	              if (!+("1")) {
	                _context2.next = 19;
	                break;
	              }
	
	              _context2.prev = 7;
	              _context2.next = 10;
	              return reCaptcha.getRecaptchaToken();
	
	            case 10:
	              recaptchaToken = _context2.sent;
	
	              self.postDataForm(recaptchaToken);
	              _context2.next = 17;
	              break;
	
	            case 14:
	              _context2.prev = 14;
	              _context2.t0 = _context2["catch"](7);
	
	              self.setState({ loginError: '<p>' + _context2.t0 + '</p>' });
	
	            case 17:
	              _context2.next = 20;
	              break;
	
	            case 19:
	              self.postDataForm();
	
	            case 20:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this, [[7, 14]]);
	    }));
	
	    function checkForm(_x2) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return checkForm;
	  }();
	
	  Login.prototype.initFacebook = function initFacebook() {
	    var self = this;
	
	    if (!document.getElementById('facebook-jssdk')) {
	      window.fbAsyncInit = function () {
	        FB.init({
	          appId: ("1714418501962045"),
	          cookie: true,
	          xfbml: true,
	          version: 'v5.0'
	        });
	      }.bind(self);
	
	      (function (d, s, id) {
	        var js,
	            fjs = d.getElementsByTagName(s)[0];
	        if (d.getElementById(id)) return;
	        js = d.createElement(s);js.id = id;
	        js.src = "https://connect.facebook.net/en_US/sdk.js";
	        fjs.parentNode.insertBefore(js, fjs);
	      })(document, 'script', 'facebook-jssdk');
	    }
	  };
	
	  Login.prototype.statusFacebookCallback = function () {
	    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(response) {
	      var recaptchaToken;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (!(response.status === 'connected')) {
	                _context3.next = 18;
	                break;
	              }
	
	              this.setState({ facebookAccessToken: response.authResponse.accessToken, facebookSignedRequest: response.authResponse.signedRequest });
	
	              if (!+("1")) {
	                _context3.next = 15;
	                break;
	              }
	
	              _context3.prev = 3;
	              _context3.next = 6;
	              return reCaptcha.getRecaptchaToken();
	
	            case 6:
	              recaptchaToken = _context3.sent;
	
	              this.postFacebookDataForm(recaptchaToken);
	              _context3.next = 13;
	              break;
	
	            case 10:
	              _context3.prev = 10;
	              _context3.t0 = _context3["catch"](3);
	
	              this.setState({ loginError: '<p>' + _context3.t0 + '</p>' });
	
	            case 13:
	              _context3.next = 16;
	              break;
	
	            case 15:
	              this.postFacebookDataForm();
	
	            case 16:
	              _context3.next = 20;
	              break;
	
	            case 18:
	              this.setState({ facebookDisabled: false });
	              this.setState({ loginError: '<p>Please log into Facebook.<br>In case you experience any difficulties, please sign in using email and password.</p>' });
	
	            case 20:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this, [[3, 10]]);
	    }));
	
	    function statusFacebookCallback(_x3) {
	      return _ref3.apply(this, arguments);
	    }
	
	    return statusFacebookCallback;
	  }();
	
	  Login.prototype.handleFacebook = function handleFacebook() {
	    var self = this,
	        CookieDialog_agreed = _reactCookies2.default.load('CookieDialog_agreed');
	    if (!CookieDialog_agreed) {
	      self.setState({ loginError: '<p>Please accept cookie policy to proceed.</p>' });
	    } else {
	      self.setState({ facebookDisabled: true });
	      self.setState({ loginError: '' });
	      FB.login(function (response) {
	        self.statusFacebookCallback(response);
	      }, { scope: 'public_profile,email' });
	    }
	  };
	
	  Login.prototype.postFacebookDataForm = function postFacebookDataForm(token) {
	    var self = this;
	    var _state2 = this.state,
	        facebookType = _state2.facebookType,
	        facebookAccessToken = _state2.facebookAccessToken,
	        facebookSignedRequest = _state2.facebookSignedRequest;
	
	    var recaptchaToken = token ? "&recaptchaToken=" + token : '';
	
	    (0, _GlobalFunctions.getJSON)('POST', '/api/facebook/auth', 'token=' + facebookAccessToken + '&code=' + facebookSignedRequest + '&type=' + facebookType + recaptchaToken, function () {
	      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(data) {
	        var dataArray, currentRecaptchaToken;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                dataArray = JSON.parse(data);
	
	                if (!(dataArray.type && dataArray.type !== facebookType)) {
	                  _context4.next = 13;
	                  break;
	                }
	
	                self.setState({ loginError: '<p class="info">' + dataArray.message + '</p>', facebookType: dataArray.type });
	
	                if (!+("1")) {
	                  _context4.next = 10;
	                  break;
	                }
	
	                _context4.next = 6;
	                return reCaptcha.getRecaptchaToken();
	
	              case 6:
	                currentRecaptchaToken = _context4.sent;
	
	                self.postDataForm(currentRecaptchaToken);
	                _context4.next = 11;
	                break;
	
	              case 10:
	                self.postDataForm();
	
	              case 11:
	                _context4.next = 22;
	                break;
	
	              case 13:
	                _context4.t0 = facebookType;
	                _context4.next = _context4.t0 === 'reactivate' ? 16 : _context4.t0 === 'proceed' ? 18 : 21;
	                break;
	
	              case 16:
	                window.location.assign(("") + '/orders/available.html');
	                return _context4.abrupt("break", 22);
	
	              case 18:
	                self.setState({ redirectPath: '/register_hash.html' });
	                self.setState({ redirectPage: true });
	                return _context4.abrupt("break", 22);
	
	              case 21:
	                window.location.assign(dataArray.redirect ? dataArray.redirect : ("") + '/orders/available.html');
	
	              case 22:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4);
	      }));
	
	      return function (_x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }(), function (status) {
	      self.setState({ statusFacebook: true });
	
	      var statusArray = JSON.parse(status);
	      if (statusArray.fields && statusArray.fields !== 'undefined') {
	        var loginErrorFields = '';
	        if (statusArray.fields.length > 0) {
	          for (var i = 0; i < statusArray.fields.length; i++) {
	            loginErrorFields += '<p>' + statusArray.fields[i] + '</p>';
	          }
	        }
	        self.setState({ loginError: loginErrorFields });
	      } else if (statusArray.message && statusArray.message !== 'undefined') {
	        self.setState({ loginError: '<p>' + statusArray.message + '</p>' });
	      }
	      self.setState({ facebookDisabled: false });
	    });
	  };
	
	  Login.prototype.componentDidMount = function componentDidMount() {
	    var self = this;
	    (0, _GlobalFunctions.getJSON)('GET', '/api/auth', null, function (data) {
	      if (data.log) {
	        window.location.assign(("") + '/orders/available.html');
	      } else {
	        self.setState({ statusPage: true });
	        self.initFacebook();
	      }
	    }, function (status) {});
	  };
	
	  Login.prototype.componentDidUpdate = function componentDidUpdate() {
	    var self = this;
	    if (this.state.statusPage) {
	      (0, _GlobalFunctions.addClass)(document.getElementsByTagName('html')[0], "login");
	      for (var fieldList = document.querySelectorAll(".input__field"), i = 0; i < fieldList.length; i++) {
	        "" !== fieldList[i].value.trim() && (0, _GlobalFunctions.addClass)(fieldList[i].parentNode, "input--filled");
	      }
	    }
	  };
	
	  Login.prototype.componentWillUnmount = function componentWillUnmount() {
	    (0, _GlobalFunctions.removeClass)(document.getElementsByTagName('html')[0], "login");
	  };
	
	  Login.prototype.render = function render() {
	
	    if (this.state && this.state.statusPage) {
	
	      if (this.state.redirectPage) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: this.state.redirectPath });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "login-wrapper" },
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: "Log in to Uvocorp.com using writer's login form - UvoCorp.com",
	          meta: [{ name: "description", content: "Enter your username and password. Log in to Uvocorp.com and view all projects that are currently available for freelance academic writers." }, { property: 'og:title', content: "Log in to Uvocorp.com using writer's login form - UvoCorp.com" }, { property: 'og:description', content: "Enter your username and password. Log in to Uvocorp.com and view all projects that are currently available for freelance academic writers." }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
	          link: [{ rel: 'canonical', href: "https://www.uvocorp.com/login.html" }] }),
	        _react2.default.createElement(
	          "div",
	          { className: "login-container" },
	          _react2.default.createElement(
	            "div",
	            { className: "login-header" },
	            " ",
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              _react2.default.createElement("img", { src: _logo2.default, alt: "UVOcorp.com" })
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "login-body" },
	            _react2.default.createElement(
	              "form",
	              { id: "loginForm", className: "form", onSubmit: this.checkForm },
	              _react2.default.createElement("div", { id: "loginError", className: "form-error", dangerouslySetInnerHTML: { __html: this.state.loginError } }),
	              _react2.default.createElement(
	                "div",
	                { className: "form-row form-row-facebook" },
	                _react2.default.createElement(
	                  "button",
	                  { id: "facebookSubmit", className: 'form-facebook', type: "button", onClick: this.handleFacebook, disabled: this.state.facebookDisabled },
	                  _react2.default.createElement(
	                    "svg",
	                    { viewBox: "0 0 20 20" },
	                    _react2.default.createElement("path", { fill: "#ffffff", d: "M15,3.6h-1.8c-1.4,0-1.7,0.7-1.7,1.7v2.2h3.4l-0.5,3.4h-2.9v8.8H8v-8.8H5V7.4h3V4.9C8,2,9.7,0.4,12.4,0.4 c1.2,0,2.3,0.1,2.6,0.1V3.6z" })
	                  ),
	                  "Log In with Facebook"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-row form-row-or" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-or" },
	                  "OR"
	                )
	              ),
	              _react2.default.createElement(_SingleInput2.default, {
	                inputType: 'email',
	                title: '',
	                name: 'loginEmail',
	                content: this.state.email,
	                controlFunc: this.handleEmailChange,
	                placeholder: 'E-mail',
	                focusFunc: this.onInputFocus,
	                blurFunc: this.onInputBlur,
	                svg: 'M13.7,16.4H6.3c-1.3,0-2.2-0.8-2.2-2.2c0-1.9,0.4-4.8,2.9-4.8c0.3,0,1.4,1.2,3,1.2c1.6,0,2.7-1.2,3-1.2c2.5,0,2.9,2.9,2.9,4.8C15.9,15.6,15,16.4,13.7,16.4z M10,10c-1.8,0-3.2-1.4-3.2-3.2S8.2,3.6,10,3.6c1.8,0,3.2,1.4,3.2,3.2S11.8,10,10,10z',
	                required: true }),
	              _react2.default.createElement(_SingleInput2.default, {
	                inputType: 'password',
	                title: '',
	                name: 'loginPassword',
	                content: this.state.password,
	                controlFunc: this.handlePasswordChange,
	                placeholder: 'Password',
	                focusFunc: this.onInputFocus,
	                blurFunc: this.onInputBlur,
	                svg: 'M14.8,15.1c0,0.4-0.4,0.8-0.8,0.8H6c-0.4,0-0.8-0.4-0.8-0.8v-4.8c0-0.4,0.4-0.8,0.8-0.8h0.3V7.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v1.6H14c0.4,0,0.8,0.4,0.8,0.8V15.1z M12.1,9.5V7.9c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v1.6H12.1z',
	                required: true }),
	              _react2.default.createElement(
	                "div",
	                { className: "form-row form-row-submit" },
	                _react2.default.createElement("input", { id: "loginSubmit", className: "form-submit", type: "submit", value: "Log In", disabled: this.state.loginDisabled }),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/forgot_password.html" },
	                  "Forgot your password?"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Need an account? ",
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/register_email.html" },
	                  "Sign up"
	                )
	              ),
	              +("1") ? _react2.default.createElement(_ReCaptcha2.default, {
	                ref: function ref(e) {
	                  return reCaptcha = e;
	                },
	                sitekey: ("6Lctl7YqAAAAALT43jzGd61IoeKmxoQVtzOTPrbo")
	              }) : ''
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "login-footer" },
	            _react2.default.createElement(
	              "ul",
	              null,
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/" },
	                  "Home"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/contacts.html" },
	                  "Contacts"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/prices.html" },
	                  "Pricing policy"
	                )
	              )
	            )
	          )
	        )
	      );
	    } else {
	      return null;
	    }
	  };
	
	  return Login;
	}(_react2.default.Component);
	
	exports.default = Login;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-login-html-js-a94ddca44b7950617a56.js